import React, { useEffect } from "react";
import DescriptionText from "./DescriptionText";
import SimpleAccordion from "./Accordion";
import GradientIndicator from "./GradientIndicator";
import { enchanceTargetLink } from "../utils/Utils";
import useDevice from "../hooks/useDevice";
import styled from "@emotion/styled";
import Discover from "./Discover";
import MainTextSkeleton from "./skeletons/MainTextSkeleton";

const Container = styled("div")(
  ({ isMobile }) =>
    isMobile && {
      paddingTop: 16,
    }
);

const MainDescription = styled("div")(({ isMobile }) => ({
  boxSizing: "border-box",
  padding: "0 16px",
  display: "flex",
  ...(isMobile && { flexDirection: "column" }),
  ...(!isMobile && { justifyContent: "space-between" }),
  fontSize: "16px",
  wordBreak: "break-word",
  hyphens: "auto",
  "a, p a": {
    color: "var(--color-purple-dark-link) !important",
  },
  ...(!isMobile && {
    "p img": {
      margin: "0 4px",
      float: "none",
    },
  }),
}));

const MainText = ({
  desc,
  cast,
  isMobile,
  isDesktop,
  isEventPage,
  data,
  loading,
}) => {
  if (!desc || !desc.description) {
    return null;
  }

  let mainText;
  let castContent = null;

  if (cast && cast.containerVisible) {
    castContent = isMobile ? (
      <SimpleAccordion data={cast.contentText} />
    ) : (
      <div id="r_castContent" className="r_castContent">
        <div>
          <div className="r_castAndCrew">
            {playdetailsv2_resources.CastHeaderResource1Text}
          </div>
        </div>
        <GradientIndicator>
          <div
            className="r_castText"
            itemProp="description"
            dangerouslySetInnerHTML={{ __html: cast.contentText }}
          />
        </GradientIndicator>
      </div>
    );
  }

  let width = "100%";

  if (!isMobile && !isEventPage) width = "810px";
  else if (!isMobile && castContent) width = "789px";

  const AvertaDiv = styled.div`
    * {
      font-family: "pf_highway_sans_pro_lightRg" !important;
    }
  `;

  mainText = (
    <Container isMobile={isMobile}>
      <MainDescription isMobile={isMobile}>
        {(isEventPage ||
          (desc.description &&
            desc.description !== "&nbsp;" &&
            desc.description !== "<br />")) && (
          <div
            className={
              isMobile ? "r_descriptionCustomText2" : "r_descriptionCustomText"
            }
            id="r_descSummary"
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
              {!isEventPage && (
                <span
                  style={{
                    color: "#0D0C1C",
                    fontSize: 20,
                    fontFamily: "pf_highway_sans_pro_mediumRg",
                  }}
                >
                  {playdetailsv2_resources.LiteralResource10Text}
                </span>
              )}
              <AvertaDiv>
                <DescriptionText
                  content={desc.description}
                  widthProp={width}
                  isEventPage={isEventPage}
                />
              </AvertaDiv>
            </div>
          </div>
        )}
        {castContent}
        {!isEventPage && isDesktop && (
          <Discover data={data} loading={loading} />
        )}
      </MainDescription>
    </Container>
  );

  return <>{mainText}</>;
};

const SummaryContent = ({ desc, cast, loading, context, data }) => {
  const { isMobile, isDesktop } = useDevice();
  const isEventPage = context === "Event";

  useEffect(() => {
    !loading && desc && enchanceTargetLink(".r_mainDescription a");
  }, [desc, cast, loading]);

  return (
    <div
      id="r_summaryText"
      className="r_summaryText"
      {...((loading || !isEventPage) && { style: { marginBottom: 0 } })}
    >
      {loading ? (
        <MainTextSkeleton isDesktop={isDesktop} />
      ) : (
        <MainText
          desc={desc}
          cast={cast}
          isMobile={isMobile}
          isDesktop={isDesktop}
          isEventPage={isEventPage}
          data={data}
          loading={loading}
        />
      )}
    </div>
  );
};

export default SummaryContent;
